import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=100a9f0b&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=100a9f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100a9f0b",
  null
  
)

export default component.exports